import styled from 'styled-components';

import { device, fonts } from 'shared/defaultTheme';

export const DashboardWrapper = styled.div`
  .home-thead {
    font-family: ${fonts.default};
    font-size: 15px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 3px;
    tr {
      height: 35px;
    }
    th {
      border-top: none;
    }
  }
  @media ${device.sm} {
    .d-flex-dashboard {
      display: block !important;
    }
    .background-box__flex-home {
      flex: 0 0 0%;
      width: 95%;
      margin-bottom: 20px;
      padding: 5px;
      .action-btn {
        display: flex;
        justify-content: center;
      }
      .home__btn {
        float: initial;
      }
    }
  }
  @media ${device.md} {
    .d-flex-dashboard {
      display: block !important;
    }
    .background-box__flex-home {
      flex: 0 0 0%;
      width: 93%;
      margin-bottom: 20px;
      padding: 22px;
      .action-btn {
        display: flex;
        justify-content: flex-end;
      }
      .home__btn {
        float: initial;
      }
    }
  }
  @media ${device.lg} {
    .d-flex-dashboard {
      display: block !important;
    }
    .background-box__flex-home {
      flex: 0 0 47%;
      .action-btn {
        display: flex;
        justify-content: flex-end;
      }
      .home__btn {
        float: initial;
      }
    }
    .background-box__flex-home-mail {
      width: 91%;
    }
  }
  @media ${device.xl} {
    .d-flex-dashboard {
      display: flex !important;
    }
    .background-box__flex-home {
      flex: 0 0 45%;
      .action-btn {
        display: flex;
        justify-content: flex-end;
      }
      .home__btn {
        float: right;
      }
    }
    .background-box__flex-home-mail {
      width: 91.6%;
    }
  }
`;
export const TdNameDocument = styled.td`
  width: 21% !important;
  div {
    display: flex;
    width: 100%;
    P {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 100px;
      @media ${device.sm} {
        width: 160px;
      }
      flex: 1 1 auto;
    }
  }
`;

export const TdNameClient = styled.td`
  width: 11% !important;
  div {
    display: flex;
    width: 100%;
    P {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 70px;
      flex: 1 1 auto;
      @media ${device.sm} {
        width: 100px;
      }
    }
  }
`;

export const TdNotifyNameClient = styled.td`
  width: 27% !important;
  div {
    display: flex;
    width: 100%;
    P {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 70px;
      @media ${device.sm} {
        width: 100px;
      }
      flex: 1 1 auto;
    }
  }
`;

export const TdNameClientCard = styled.td`
  div {
    display: flex;
    width: 100%;
    P {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 160px;
      @media ${device.sm} {
        width: 100px;
      }
      flex: 1 1 auto;
    }
  }
`;
